import { render, staticRenderFns } from "./UserDefinedFields.vue?vue&type=template&id=e1fd217a&"
import script from "./UserDefinedFields.vue?vue&type=script&lang=js&"
export * from "./UserDefinedFields.vue?vue&type=script&lang=js&"
import style0 from "./UserDefinedFields.vue?vue&type=style&index=0&id=e1fd217a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports